module.exports = __webpack_public_path__ + "imgascvts/Bus.6696bdda.png";